<template>
  <div>
    <div v-if="showDeleteConfirmationModal">
      <DeleteConfirmationModal
        :modalShow="showDeleteConfirmationModal"
        :projectToDelete="projectToDelete"
        @toggle="closeModal"
        @delete="deleteProject"
      />
    </div>
    <div v-if="showEditProjectModal">
      <EditProjectModal
        title="Edit Project"
        :modalShow="showEditProjectModal"
        :projectToModify="projectToModify"
        @toggle="closeModal('editProjectModal')"
        @update="updateProjectInfo"
      />
    </div>

    <b-table class="project-table" hover :items="projects" :fields="fields">
      <template #thead-top="">
        <b-tr>
          <b-th colspan="4" class="border-top-0"></b-th>
          <b-th class="border-top-0 text-right">
            <b-button variant="outline-primary" @click="newProjectBtnClicked">
              <b-icon icon="folder-plus" aria-hidden="true"></b-icon> New
              Project
            </b-button></b-th
          >
        </b-tr>
      </template>
      <template #cell(projectName)="row">
        <span v-b-tooltip.hover.html="tooltipMsg('openProject')">
          <router-link
            :to="{
              path: '/project-searchdocs-dashboard/',
              query: { projectID: row.item.projectID },
            }"
            class="project-name"
            ><span>
              {{ row.item.projectName }}
            </span></router-link
          >
        </span>
      </template>
      <template #cell(lastModifiedTime)="row">
        <span>
          {{ row.item.lastModifiedTime }}
        </span>
      </template>
      <template #cell(actions)="row">
        <div class="action">
          <!-- tooltip added to wrapper of button so that it works even if 
					button is disabled -->
          <!-- @todo this shuold be its own component eventually -->
          <span
            v-b-tooltip.hover.html="
              tooltipMsg('editProject', row.item.owner === curUser.email)
            "
          >
            <b-button
              size="sm"
              variant="primary"
              class="mb-2 action-btn"
              :disabled="row.item.owner !== curUser.email"
              @click="openModal('editProjectModal', row.item)"
            >
              <b-icon icon="pencil-fill" aria-label="Edit"></b-icon>
            </b-button>
          </span>
          <span
            v-b-tooltip.hover.html="
              tooltipMsg('deleteProject', row.item.owner === curUser.email)
            "
          >
            <b-button
              size="sm"
              variant="primary"
              class="mb-2 action-btn"
              :disabled="
                projects.length === 1 || row.item.owner !== curUser.email
              "
              @click="openModal('deleteConfirmationModal', row.item)"
            >
              <b-icon icon="trash-fill" aria-label="Delete"></b-icon>
            </b-button>
          </span>
        </div> </template
    ></b-table>
  </div>
</template>

<script>
import DeleteConfirmationModal from '@/components/modals/ProjectDeleteConfirmModal.vue';
import EditProjectModal from '@/components/modals/EditProjectModal.vue';
import { getCurUser } from '../constants/fromLocalStorageConstants';
export default {
  name: 'ProjectList',
  components: {
    DeleteConfirmationModal,
    EditProjectModal,
  },
  props: {
    projects: Array,
  },
  data() {
    return {
      fields: [
        {
          key: 'projectName',
          label: 'Project Name',
        },
        {
          key: 'lastModifiedTime',
          label: 'Last Modified',
        },
        {
          key: 'createdTime',
          label: 'Created',
        },
        { key: 'actions', label: 'Actions' },
        {
          key: 'owner',
          label: 'Owner',
        },
      ],
      showDeleteConfirmationModal: false,
      projectToDelete: null,
      showEditProjectModal: false,
      projectToModify: null,
    };
  },
  computed: {
    curUser() {
      return getCurUser();
    },
  },
  methods: {
    tooltipMsg(source, isOwner = true) {
      if (!isOwner && ['deleteProject', 'editProject'].includes(source)) {
        return 'You can only access project actions if you are the owner of a project.';
      }

      if (source === 'deleteProject') {
        return this.projects.length > 1
          ? 'Delete project'
          : 'Can not delete. You must have at least one project.';
      } else if (source === 'editProject') {
        return 'Edit project';
      } else if (source === 'openProject') {
        return 'Click to see project dashboard.';
      }
      return '';
    },
    deleteProject() {
      if (this.projectToDelete) {
        this.$emit('deleteProject', this.projectToDelete.projectID);
        this.projectToDelete = null;
        this.closeModal('deleteConfirmationModal');
      }
      //todo:save deleted project list to database
    },
    updateProjectInfo({
      projectID,
      description,
      projectName,
      inviteUsers,
      deleteUsers,
    }) {
      if (this.projectToModify) {
        this.$emit('updateProject', {
          projectID,
          description,
          projectName,
          inviteUsers,
          deleteUsers,
        });
        this.projectToModify = null;
        this.closeModal('editProjectModal');
      }
    },
    openModal(modalName, projectSelected) {
      if (modalName === 'deleteConfirmationModal') {
        this.showDeleteConfirmationModal = true;
        this.projectToDelete = projectSelected;
      } else if (modalName === 'editProjectModal') {
        this.showEditProjectModal = true;
        this.projectToModify = projectSelected;
      }
    },
    closeModal(modalName) {
      if (modalName === 'deleteConfirmationModal') {
        this.showDeleteConfirmationModal = false;
      } else if (modalName === 'editProjectModal') {
        this.showEditProjectModal = false;
      }
    },
    newProjectBtnClicked() {
      this.$emit('newProjectBtnClicked');
    },
  },
};
</script>

<style scoped>
.project-table {
  margin-top: 2em;
  margin-left: 20%;
  width: 60%;
}
.action {
  display: flex;
  /* justify-content: flex-start; */
  justify-content: space-between;
  width: 90px;
}
.action-btn {
  width: 35px;
  text-align: center;
}
.project-name {
  text-decoration: none;
}
</style>
